module.exports = __webpack_public_path__ + "img/engravingSymbols@2x.7b3053b.jpg";